<template>
    <div>
        <Row :gutter="4">
            <!-- 请选择标准标签 -->
            <Col span="4">
                <Select v-model="standardTagId" filterable :placeholder="$t('tag.pleaseSelectStandardTag')" :transfer="true" @on-change="changeStandardTagId">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in standardTagList" :key="item.id">{{item.keyName}}</Option>
                </Select>
            </Col>
            <!-- 设置标签映射 -->
            <Col span="8">
                <Button type="primary" @click="setUpTagMappingVisible=true" >{{$t('tag.setUpTagMapping') }}</Button>
            </Col>
        </Row>
        <!-- 设置标签映射 -->
        <Modal v-model="setUpTagMappingVisible" :title="$t('tag.addMappingTag')" :loading="loadingAddMapping" :mask-closable="false" width="800px;" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')" :styles="{top:'35px'}">
            <Form ref="addTagMappingForm" :model="addTagMappingForm" label-position="left" :label-width="60">
                <Row :gutter="12">
                    <Col span="8">
                        <!-- 标准标签 -->
                        <FormItem :label="$t('tag.standardTag')" prop="mappingStandardTagId">
                            <Select v-model="addTagMappingForm.mappingStandardTagId" filterable :placeholder="$t('tag.pleaseSelectStandardTag')" :transfer="true">
                                <Option :value="item.id" v-for="item in mappingStandardTagList" :key="item.id">{{item.keyName}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <!-- 搜索标签 -->
                        <FormItem :label="$t('tag.tagName')" prop="searchKey">
                            <Input search v-model="addTagMappingForm.searchKey" :placeholder="$t('tag.pleaseInputTag')"/>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <Button type="primary" @click="searchMappingKey" >{{$t('tag.search') }}</Button>
                        <Button type="primary" @click="updateKey" :disabled="isDisable">{{$t('tag.update') }}</Button>
                    </Col>
                </Row>
                <!--标签组-->
                <Table :no-data-text="$t('common.noData')" ref="selection" @on-selection-change="getSelection" :columns="tagMappingTableColumn" :data="tagMappingSetData" style="width: 100%;" :height="400"></Table>
            </Form>
            <div slot="footer">
                <Button @click="cancelTagMapping('addTagMappingForm')">{{$t('permission_configuration_management.common.cancel')}}</Button>
                <Button type="primary" @click="addTagMappingSubmit('addTagMappingForm')" :loading="addloading" :disabled="isDisable">{{$t('permission_configuration_management.common.confirm')}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import TableTagMapping from '../tag_management/TableTagMapping';

    const tableTagMapping = TableTagMapping;
    let tagMappingSearch = {};
    export default {
        name: 'TagMappingSearch',
        components: {
            tableTagMapping
        },
        data() {
            return {
                standardTagId: '',
                standardTagList: [],//查询
                addloading:false,
                isDisable: true,
                setUpTagMappingVisible:false,
                loadingAddMapping:true,
                selection: [],
                mappingStandardTagList: [],
                addTagMappingForm:{
                    mappingStandardTagId: '',
                    searchKey:''
                },
                tagMappingTableColumn: [
                {
                    width: 60,
                    titleAlign: 'center',
                    columnAlign: 'center',
                    type: 'selection'
                },
                {
                    title: this.$t('tag.tag'),
                    key: 'keyName'
                }],
                tagMappingSetData: [],
                selectedTagArray:[]
            }
        },
        beforeCreate: function () {
            tagMappingSearch = this
        },
        mounted() {
            this.getStandardTagDropDownBox();
        },
        methods: {
            // 切换标准标签
            changeStandardTagId: function () {
                eventBus.$emit('standardTagId', this.standardTagId);
                tableTagMapping.methods.showAll();
            },
            // 获取标准标签下拉框
            getStandardTagDropDownBox: function () {
                this.$api.tag.getStandardTagList()
                .then(res => {
                    this.standardTagList = res.data;
                    this.mappingStandardTagList = res.data;
                });
            },
            // 多选 
            /************************************************************************/
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.selectedTagArray = [];
                for (var i = 0; i < this.selection.length; i++) {
                    this.selectedTagArray.push(this.selection[i].keyName);
                }
                // 选了数据 可以点击添加
                if (this.selectedTagArray.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 根据标签查询资源
            searchMappingKey: function () {
                this.selectedTagArray=[];
                if (this.selectedTagArray.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
                this.$api.tag.queryTagGroupByTagKey({
                    "pageNum": 1,
                    "pageSize": 100000,
                    "tagKey": this.addTagMappingForm.searchKey,
                    "mappingStandardTagId":this.addTagMappingForm.mappingStandardTagId
                })
                .then(res => {
                    this.tagMappingSetData = res.data.records;
                })
            },
            // 提交
            addTagMappingSubmit: function (name) {
                const updateData = {
                    "standardTagId": this.addTagMappingForm.mappingStandardTagId,
                    "selectedTagArray":this.selectedTagArray
                };
                // 添加映射标签
                this.addloading=true;
                this.$api.tag.addMappingTag(updateData)
                .then(res => {
                    setTimeout(() => {
                        tableTagMapping.methods.showAll();
                        this.$refs[name].resetFields();
                        this.loadingAddMapping = false;
                        this.$nextTick(() => {
                            this.loadingAddMapping = true;
                        });
                        this.$Message.success('添加标签映射成功');
                        this.tagMappingSetData=[];
                        this.selectedTagArray=[];
                        this.addloading=false;
                        this.isDisable = true;
                        this.setUpTagMappingVisible = false;
                    }, 1000);
                })
            },
            // 取消
            cancelTagMapping: function (name) {
                this.isDisable = true;
                this.setUpTagMappingVisible = false;
                this.tagMappingSetData=[];
                this.selectedTagArray=[];
                this.$refs[name].resetFields();
            },
            // 更新
            updateKey:function(){
                this.searchMappingKey();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/TagMappingSearch.vue